import * as React from 'react';

import { ISVGProps } from '../../../types';

// tslint:disable:max-line-length
export const PromotionsSaleIcon = (props: ISVGProps) => (
  <svg {...props} xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26">
    <g fill="none" fillRule="evenodd">
      <circle cx="13" cy="13" r="13" fill="#EA4F6B" />
      <g fill="#FFF">
        <path d="M16.934 7.059l.997.775-9.31 11.375-.997-.775zM9.137 13a2.897 2.897 0 1 1 0-5.794 2.897 2.897 0 0 1 0 5.794zm0-1.395a1.502 1.502 0 1 0 0-3.004 1.502 1.502 0 0 0 0 3.004zM16.38 18.794a2.897 2.897 0 1 1 0-5.794 2.897 2.897 0 0 1 0 5.794zm0-1.395a1.502 1.502 0 1 0 0-3.004 1.502 1.502 0 0 0 0 3.004z" />
      </g>
    </g>
  </svg>
);
